export const iconfield = {
  icon: {
    color: "{form.field.icon.color}",
  },
};
